import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37aa2cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container header__container" }
const _hoisted_3 = { class: "header__container-logoBlock" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__logo-mobile" }, null, -1))
const _hoisted_6 = { class: "header__container-actionsBlock" }
const _hoisted_7 = { class: "items-in-line gap--9" }
const _hoisted_8 = { class: "header__container-actionsBlock-mobileMenu" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "header__menu" }

import MenuComponent from '@/components/Menu/Menu.vue';
import ActionsBlock from './ActionsBlock/ActionsBlock.vue';
import { useUserStore } from '@/store/modules/user';
import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { useRouter } from 'vue-router';
import { checkUserLoginHandler } from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const backLink = computed(() => {
  const url =
    process.env.VUE_APP_IS_DEV === 'true'
      ? 'http://localhost:13010'
      : useAppStore().baseUrl;

  return url + `/back`;
});

const currentRegion = computed((): number | undefined => {
  return useAppStore().regions_for_select.defaultForUser;
});

const updateRegion = (region: number) => {
  useAppStore().updateRegion(region);
};
const regionsOptions = computed(() => {
  return useAppStore().regions_for_select.regions;
});
const router = useRouter();
const resetFilters = async () => {
  useOfferCardsStore().returnToInitialState();
  await router.push({ name: 'main' });

  await router.replace({ query: undefined });
};

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_divider = _resolveComponent("base-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", { onClick: resetFilters }, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/header/logo.svg'),
              class: "header__container-logoBlock-logo",
              contain: "",
              height: "45",
              name: "logo",
              width: "204"
            }, null, 8, ["src"]),
            _hoisted_5
          ])
        ]),
        _createVNode(_component_base_select_input, {
          modelValue: currentRegion.value,
          options: regionsOptions.value,
          arrow: "expand_more",
          class: "header__container-logoBlock-region",
          height: "25",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateRegion($event)))
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ActionsBlock),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(MenuComponent)
          ]),
          (_unref(useUserStore)().user?.access.includes('back'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: backLink.value,
                class: "header__container-admin-btn center pointer",
                target: "_blank"
              }, "Back", 8, _hoisted_9))
            : _createCommentVNode("", true),
          _createVNode(_component_base_button, {
            class: "no-wrap",
            "style-type": "coloredBorder",
            text: "Объявление +",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
              _unref(checkUserLoginHandler)().then(() => {
                _unref(router).push({
                  name: 'profile',
                  params: { id: 'myAnnouncements' },
                  hash: '#create',
                });
              })
            })
          }),
          (_unref(useUserStore)().user)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'profile' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_button, { text: "Профиль" })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_base_button, {
                key: 2,
                text: "Войти",
                onClick: _unref(useAppStore)().openAuthModal
              }, null, 8, ["onClick"]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(MenuComponent)
    ]),
    _createVNode(_component_base_divider, { class: "header__mobile-divider" })
  ]))
}
}

})